module.exports = __webpack_public_path__ + "img/34_20.588d7b75.png";